import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "plusCircle"
const PlusCircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.75 11.25H18.364V12.75H12.75V18.364H11.25V12.75H5.636V11.25H11.25V5.636H12.75z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PlusCircleIcon
